// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "bootstrap"

document.addEventListener("DOMContentLoaded", function () {
  // setTimeout(() => {
  //   document.querySelectorAll(".alert").forEach((alert) => {
  //     alert.classList.add("fade"); // Adds Bootstrap's fade-out class
  //     setTimeout(() => alert.remove(), 500); // Removes element after fade effect
  //   });
  // }, 3000);
});
